import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import tabbar from "./tabbar"
import system from "./systemConfig"
import coins from '../view/p2p/models'
import address from "./addressManage"
import systemConfig from './system'
import { Api } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  state: {
    PopUp: false,
    index: 0,
    levels: []
  },
  actions:{
    verifyRes(content, { ret, msg, data }) {
      return new Promise((resolve, reject) => {
        if (ret == -1) {
          router.replace('/login')
          return reject({ ret, msg })
        }
        if (ret == 1) {
          return resolve(data)
        }
        Toast(msg)
        return reject({ ret, msg })
      })
    },
  },
  mutations: {
    updataCount (state,data){
      state.PopUp = data
    },
    upindex(state, data) {
      state.index = data
    },
    getLevel(state){
      Api.getLevel(res=>{
        state.levels = res;
      })
    }
  },
  modules: {
    user,
    tabbar,
    system,
    coins,
    address,
    systemConfig
  }
})
